import client from 'src/api/apollo/client';
import { COMPANY_UPDATE } from 'src/api/graphql/mutations/company.gql';
import { createGraphqlRequestError } from 'src/utils/helpers/getGraphqlErrorMessage';

export const updateCompany = async (id, input) => {
	try {
		const { data } = await client.mutate({
			mutation: COMPANY_UPDATE,
			variables: {
				id: String(id),
				input,
			},
		});

		return data.CompanyUpdate.company;
	} catch (error) {
		throw createGraphqlRequestError(error, 'Не удалось сохранить компанию');
	}
};
